const Main = props => {

    return (
        <main className="application-wrapper">
            { props.children }            
        </main>
    )
}

export default Main